import { MouseEvent } from "react";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { BlobStatusFilter } from "../utils/filters";

interface StatusFilterProps {
  value: BlobStatusFilter;
  onChange: (value: BlobStatusFilter) => void;
}

const options: { value: BlobStatusFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "available", label: "Available" },
  { value: "archived", label: "Archived" },
  { value: "deleted", label: "Deleted" },
];

const StatusFilter = ({ value, onChange }: StatusFilterProps) => {
  const handleChange = (
    _event: MouseEvent<HTMLElement>,
    newValue: BlobStatusFilter | null,
  ) => {
    if (newValue !== null) onChange(newValue);
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size="small"
      sx={{
        "& .MuiToggleButton-root": {
          px: 1.5,
          py: 0.5,
          fontSize: "0.813rem",
          textTransform: "none",
          border: "1px solid",
          borderColor: "divider",
          "&.Mui-selected": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
          "&:hover": {
            backgroundColor: "action.hover",
          },
        },
      }}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          aria-label={option.label}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default StatusFilter;
